import React from 'react';
import { Navigate } from 'react-router-dom';

import LoadingSkeleton from '@/shared/components/ui/LoadingSkeleton';
import { useAuth } from '@/shared/hooks/useAuth';
import { useDefaultRoute } from '@/shared/hooks/useFeatures';

const DefaultRedirect: React.FC = () => {
  const { isLoading } = useAuth();
  const defaultRoute = useDefaultRoute();

  if (isLoading) {
    return <LoadingSkeleton />;
  }

  return <Navigate to={defaultRoute} replace={true} />;
};

export default DefaultRedirect;
